import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarDirective
} from "ngx-perfect-scrollbar";
import { filter, map } from "rxjs/internal/operators";

import { BreakpointObserver } from "@angular/cdk/layout";
import { Tab } from 'src/app/core/admin-layout/tab.model';
import { TabService } from './tab.service';
import { PrintService } from "src/app/shared/print.service";
import { AMControllerService } from "src/app/shared/dbcontroller/dbcontroller.service";

const SMALL_WIDTH_BREAKPOINT = 960;

@Component({
  selector: "app-layout",
  styleUrls: ["./admin-layout.coponent.scss"],
  template: `
    <app-layout-inner
      [isScreenSmall]="isScreenSmall | async"
    ></app-layout-inner>
  `,
  encapsulation: ViewEncapsulation.None
})
export class AdminLayoutComponent {
  isScreenSmall: Observable<boolean>;

  constructor(public breakpoints: BreakpointObserver) {
    this.isScreenSmall = breakpoints
      .observe(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`)
      .pipe(map(breakpoint => breakpoint.matches));
  }
}

@Component({
  selector: "app-layout-inner",
  templateUrl: "./admin-layout.component.html"
})
export class LayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  private layoutRouter: Subscription;
  NowPrintingEvent: any;
  @Input() isScreenSmall: boolean;
  tabs = new Array<Tab>();
  selectedTab: number;

  url: string;
  sidePanelOpened;
  options = {
    collapsed: true,
    boxed: false,
    dark: false,
    dir: "ltr"
  };

  @ViewChild("sidemenu", { static: true }) sidemenu;
  @ViewChild(PerfectScrollbarDirective, { static: true })
  directiveScroll: PerfectScrollbarDirective;

  public config: PerfectScrollbarConfigInterface = {};
  constructor(private router: Router, public tabService: TabService,public controllerService: AMControllerService, private changeDetector: ChangeDetectorRef,public printService: PrintService) { }


  ngAfterViewInit(): void {
    this.changeDetector.detectChanges();
  }


  ngOnInit(): void {

    // this.tabs = this.tabService.tabs;
    this.NowPrintingEvent = this.printService.NowPrintingEvent.subscribe(data => this.sidemenu.toggle());

    this.layoutRouter = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        document.querySelector(
          ".app-inner > .mat-drawer-content > div"
        ).scrollTop = 0;
        this.url = event.url;
        this.runOnRouteChange();
      });

    this.tabService.tabSub.subscribe(tabs => {
      this.tabs = tabs;
    });

    this.tabService.tabChengedEvent.subscribe(tabIndex => { this.selectedTab = tabIndex });
  }
  
  tabChanged(event) {
    this.selectedTab = event.index;
  }

  removeTab(index: number): void {
    this.tabService.removeTab(index);
  }

  ngOnDestroy(): void {
    this.layoutRouter.unsubscribe();
  }

  runOnRouteChange(): void {
    if (this.isOver()) {
      this.sidemenu.close();
    }

    this.updatePS();
  }

  receiveOptions($event): void {
    this.options = $event;
  }

  isOver(): boolean {
    if (
      this.url === "/apps/messages" ||
      this.url === "/apps/calendar" ||
      this.url === "/apps/media" ||
      this.url === "/maps/leaflet" ||
      this.url === "/taskboard"
    ) {
      return true;
    } else {
      return this.isScreenSmall;
    }
  }

  menuMouseOver(): void {
    if (this.isScreenSmall && this.options.collapsed) {
      this.sidemenu.mode = "over";
    }
  }

  menuMouseOut(): void {
    if (this.isScreenSmall && this.options.collapsed) {
      this.sidemenu.mode = "side";
    }
  }

  updatePS(): void {
    if (!this.isScreenSmall) {
      setTimeout(() => {
        this.directiveScroll.update();
      }, 350);
    }
  }
}
